'use client';

import type { ForwardedRef } from 'react';
import { forwardRef } from '../../forward-ref.js';
import { Checkbox } from '../checkbox/checkbox.js';
import type { CommonProps, LabellableProps } from '../types.js';
import { useTableState } from './contexts/table-state.js';

export interface TableAllRowsSelectorProps extends CommonProps, Omit<LabellableProps, 'label'> {}

function TableAllRowsSelector(props: TableAllRowsSelectorProps, ref: ForwardedRef<HTMLLabelElement>) {
  const { rowSelectionMode, areAllRowsSelected, areSomeRowsSelected, onAllRowsSelectionToggle } = useTableState();

  if (rowSelectionMode !== 'multiple') {
    return null;
  }

  return (
    <Checkbox
      {...props}
      ref={ref}
      isSelected={areAllRowsSelected}
      isIndeterminate={areSomeRowsSelected}
      onChange={onAllRowsSelectionToggle}
    />
  );
}

/**
 * Controls the selection state of all rows within a table.
 *
 * See [table building guide](https://ui.cimpress.io/dev-guides/tables/).
 */
const _TableAllRowsSelector = forwardRef(TableAllRowsSelector, 'TableAllRowsSelector');

export { _TableAllRowsSelector as TableAllRowsSelector };
